import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, SHIPPING_AUTOMATION } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const DeliveryCompanyFeasibilitiesList = () => {
	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);

	const columns = useMemo(
		() => [
			{
				Header: 'id',
				accessor: 'id',
				width: 60,
				filterType: FilterType.number,
				showOnMobile: true
			},
			{
				Header: 'deliveryCompany',
				accessor: 'dcName',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'action',
				accessor: 'actionType',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'status',
				accessor: 'status',
				width: 130,
				renderCell: ListComponents.STATUS,
				filterType: FilterType.enumMulti,
				enumName: ENUMS.FEASIBILITY_STATUS,
				showOnMobile: true
			}
		],
		[]
	);

	return (
		<div>
			<DynamicList
				id={DYNAMICLISTS.DELIVERY_COMPANY_FEASIBILITIES}
				columns={columns}
				fetchUrl={SHIPPING_AUTOMATION.GET_DC_FEASIBILITY_RULE_LIST}
				defaultSort={defaultSort}
				actionObjectType={ACTION_OBJECT_TYPES.OTHER}
			/>
		</div>
	);
};

export default DeliveryCompanyFeasibilitiesList;
